
import WorkbenchIndex from "../views/workbench/Index.vue";
import PersonalIndex from "../views/workbench/personal/Index.vue";
import PersonalAccount from "../views/workbench/personal/account/HomeView.vue";
import PersonalAuth from "../views/workbench/personal/auth/index.vue";
import PersonalHome from "../views/workbench/personal/home/index.vue";
import PersonalRelease from "../views/workbench/personal/release/index.vue";
import PersonalCollection from "../views/workbench/personal/collection/index.vue";
import PersonalOrder from "../views/workbench/personal/order/index.vue";
import PersonalFollow from "../views/workbench/personal/follow/index.vue";
import PersonalExpense from "../views/workbench/personal/expense/index.vue";
import PersonalAssets from "../views/workbench/personal/assets/index.vue";
import AssetsLibIndex from "../views/workbench/assetsLib/Index.vue";
import AssetsLibHome from "../views/workbench/assetsLib/home/index.vue";
import AssetsLibAsset from "../views/workbench/assetsLib/asset/index.vue";



export const routes = {
    path: '/workbench',
    name: 'workbench',
    component: WorkbenchIndex,
    redirect: '/workbench/personal',
    children: [
        {
            path: 'personal',
            component: PersonalIndex,
            redirect: "/workbench/personal/home",
            children: [
                {
                    path: 'home',
                    name: 'workbench-personal-home',
                    component: PersonalHome,
                },
                {   
                    path: 'account',
                    name: 'workbench-personal-account',
                    component: PersonalAccount,
                },
                {
                    path: 'auth',
                    name: 'workbench-personal-auth',
                    component: PersonalAuth,
                },
                {
                    path: 'release',
                    name: 'workbench-personal-release',
                    component: PersonalRelease,
                },
                {
                    path: 'collection',
                    name: 'workbench-personal-collection',
                    component: PersonalCollection,
                },
                {
                    path: 'follow',
                    name: 'workbench-personal-follow',
                    component: PersonalFollow,
                },
                {
                    path: 'order',
                    name: 'workbench-personal-order',
                    component: PersonalOrder,
                },
                {
                    path: 'expense',
                    name: 'workbench-personal-expense',
                    component: PersonalExpense,
                },
                {
                    path: 'assets',
                    name: 'workbench-personal-assets',
                    component: PersonalAssets,
                }
            ]
        },
        {
            path: 'assets-lib',
            component: AssetsLibIndex,
            redirect: "/workbench/assets-lib/home",
            children: [
                {
                    path: 'home',
                    name: 'workbench-assets-lib-home',
                    component: AssetsLibHome,
                },
                {
                    path: 'asset',
                    name: 'workbench-assets-lib-asset',
                    component: AssetsLibAsset,
                }
            ]
        }
    ]
}